/**
 * Note: using a signal will opt-out the fetch request from Next.js`s deduplication funtionality.
 *
 * References:
 *  - https://nextjs.org/docs/15/app/getting-started/fetching-data#deduplicate-requests-and-cache-data
 *  - https://github.com/vercel/next.js/blob/canary/packages/next/src/server/lib/dedupe-fetch.ts
 */
export const getFetchWithTimeout = (fetchFn: typeof fetch, timeout: number): typeof fetch => {
    return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
        return await fetchFn(input, { signal: AbortSignal.timeout(timeout), ...init });
    };
};
